import React, { useState, useEffect, useRef, useCallback } from "react";
import "../pages.css";
import { useLocation } from "react-router-dom";

// import { posts as llb_posts } from "../../../public/data/littlelightbulbmoments/posts";
function Template(props) {
  const [posts, setposts] = useState([]);
  const location = useLocation();
  const poemRefs = useRef({});

  const [filteredPosts, setfilteredPosts] = useState([]);
  const [selectedPost, setSelectedPost] = useState(null);

  const setPoemRef = useCallback((element, name) => {
    console.log("element", element, "name", name);
    poemRefs.current[name] = element;
  }, []);

  useEffect(() => {
    if (posts && posts.length > 0 && location.hash) {
      const elementId = decodeURIComponent(
        location.hash.substring(1)
      ).replaceAll(" ", "-");
      
      const foundPost = posts.find((p) => p.name.replace(/\s+/g, "-") === elementId);
      if (foundPost) {
        setSelectedPost(foundPost);
        window.scrollTo(0, 0);
      }
    } else {
      setSelectedPost(null);
    }
  }, [location.hash, posts]);

  useEffect(() => {
    setSelectedPost(null);
    fetch("/data/" + props.component + "/posts.js") // Relative to the public directory in the build
      .then((response) => {
        if (!response.ok) {
          // Check if the response was successful
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json(); // Parse the response body as JSON
      })
      .then((jsonData) => {
        setposts(jsonData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        // Handle the error, e.g., display an error message to the user
      });
  }, [props.component]);

  useEffect(() => {
    setfilteredPosts(posts);
  }, [posts]);

  return (
    <div className="container">
      <div className="content">
        <section className="person-section" style={{ width: '100%' }}>
          <header>
            {props.component === "people" && <h2>People I've Met</h2>}
            {props.component === "places" && <h2>Places I've Been</h2>}
            {props.component === "voices" && <h2>Voices I've Heard</h2>}
            {props.component === "faces" && <h2>Faces I've Seen</h2>}
            {props.component === "littlelightbulbmoments" && (
              <h2>Little Light Bulb Moments</h2>
            )}
            {props.component === "colour-me-green" && <h2>Colour Me Green</h2>}
          </header>
          {!selectedPost ? (
            <div className="card-grid">
              {filteredPosts.map((data, idx) => {
                const words = (data.post || "").split(" ");
                const excerpt = words.slice(0, 20).join(" ") + (words.length > 20 ? "..." : "");

                return (
                  <div className="post-card" key={idx} onClick={() => {
                    setSelectedPost(data);
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}>
                    <div className="post-card-img-placeholder">
                      {data.photo ? (
                         <img src={`/data/${props.component}/assets/${data.photo}`} alt={data.name} />
                      ) : null}
                      {data.photo && data.credit ? (
                        <span className="post-card-credit">
                          {data.creditUrl ? (
                            <a
                              href={data.creditUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              {data.credit}
                            </a>
                          ) : (
                            data.credit
                          )}
                        </span>
                      ) : null}
                    </div>
                    <div className="post-card-content">
                      <h3 className="post-card-title">{data.name}</h3>
                      <p className="post-card-excerpt">{excerpt}</p>
                      {typeof data.tags === 'string' && (
                        <span className="hidden-tags" style={{ display: 'none' }}>
                          {data.tags.replace(/#/g, '')}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div>
              {(() => {
                const data = selectedPost;
                const detectPostType = (postData) => {
                  if (postData.type) return postData.type;
                  if (!postData.post) return "essay";
                  const lines = postData.post.split("\n").map(l => l.trim()).filter(l => l.length > 0);
                  if (lines.length === 0) return "essay";
                  const avgLength = lines.reduce((sum, line) => sum + line.length, 0) / lines.length;
                  return avgLength < 80 ? "poem" : "essay";
                };
                const postType = detectPostType(data);

                const safeId = data.name.replace(/\s+/g, "-");
                const currentLayout = data.layout || (postType === "poem" ? "left" : "top");
                const layoutClass = `layout-${currentLayout}`;
                const isImageOnly = !data.post || data.post.trim() === "";
                const defaultPhotoSize = isImageOnly ? "large" : "medium";
                const photoSizeClass = data.photoSize || defaultPhotoSize;
                const aspectClass = postType === "poem" ? " aspect-portrait" : " aspect-landscape";
                const customClass = (data.customClass ? ` ${data.customClass}` : "") + aspectClass;

                return (
                  <div
                    className={`person ${layoutClass}`}
                    id={safeId}
                    key={data.name}
                    ref={(element) => setPoemRef(element, safeId)}>
                    {(currentLayout === "top" || currentLayout === "left") &&
                      data.photo && (
                        <figure className="image-figure">
                          <img
                            className={`${photoSizeClass}${customClass}`}
                            src={`/data/${props.component}/assets/${data.photo}`}
                            alt={data.name}
                          />
                          {data.credit ? (
                            <figcaption className="image-credit">
                              {data.creditUrl ? (
                                <a
                                  href={data.creditUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {data.credit}
                                </a>
                              ) : (
                                data.credit
                              )}
                            </figcaption>
                          ) : null}
                        </figure>
                      )}

                    <div className="text-content">
                      <h3>{data.name}</h3>
                      <p className="date">
                        {data.date && <>{data.date}</>}
                      </p>
                      {typeof data.tags === 'string' && (
                        <div className="hidden-tags" style={{ display: 'none' }}>
                          {data.tags.replace(/#/g, '')}
                        </div>
                      )}
                      <div className={`description format-${postType}`}>
                        {(data.post || "").split("\n").map((line, index) => (
                          <p key={index}>{line}</p>
                        ))}
                      </div>
                    </div>

                    {(currentLayout === "bottom" || currentLayout === "right") &&
                      data.photo && (
                        <figure className="image-figure">
                          <img
                            className={`${photoSizeClass}${customClass}`}
                            src={`/data/${props.component}/assets/${data.photo}`}
                            alt={data.name}
                          />
                          {data.credit ? (
                            <figcaption className="image-credit">
                              {data.creditUrl ? (
                                <a
                                  href={data.creditUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {data.credit}
                                </a>
                              ) : (
                                data.credit
                              )}
                            </figcaption>
                          ) : null}
                        </figure>
                      )}
                  </div>
                );
              })()}
              <div style={{ marginTop: '30px', textAlign: 'center' }}>
                <button className="back-button" onClick={() => setSelectedPost(null)}>← Back to Posts</button>
              </div>
            </div>
          )}
        </section>


      </div>
    </div>
  );
}

export default Template;
